import React from "react";

const ModuleFeatures = ({ features }) => (
  <section className="mk-section" data-testid="module-section-features">
    <div className="mk-wrap">
      <div className="mk-section-head mk-reveal">
        <div>
          <h2>Fonctionnalités principales</h2>
        </div>
      </div>
      <div className="mk-features">
        {features.map((f) => (
          <article key={f.title} className="mk-feature mk-reveal">
            <div className="mk-icon">{f.icon}</div>
            <h3>{f.title}</h3>
            <p>{f.desc}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default ModuleFeatures;
